import { Autocomplete, Box, Checkbox, TextField } from "@mui/material";
import type { SyntheticEvent } from "react";
import type { FilterRenderProps } from "../../grid/CompGrid";

export interface GridCheckboxSearchFilterPopoverProps extends FilterRenderProps {
  label: string;
  options: string[];
  placeholder?: string;
}

export function GridCheckboxSearchFilterPopover({
  value,
  onChange,
  label,
  options,
  placeholder = "Search...",
}: GridCheckboxSearchFilterPopoverProps) {
  const selected = (Array.isArray(value) ? value : []) as string[];

  const handleChange = (_event: SyntheticEvent, newValue: string[]) => {
    onChange(newValue);
  };

  return (
    <Box sx={{ minWidth: 220 }}>
      <Autocomplete
        multiple
        options={options}
        value={selected}
        onChange={handleChange}
        size="small"
        disableCloseOnSelect
        renderOption={(props, option, { selected: isSelected }) => (
          <li {...props}>
            <Checkbox size="small" sx={{ mr: 1 }} checked={isSelected} />
            {option}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            size="small"
          />
        )}
      />
    </Box>
  );
}